import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, EnvelopeSimple, ArrowUpRight } from "@phosphor-icons/react";
import Logo from "../Logo";
import { useLang } from "../../i18n/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#0E0E0E] text-neutral-300" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 text-sm leading-relaxed text-neutral-400 max-w-md">
              {t.footer.tagline}
            </p>
            <div className="mt-8 inline-flex items-center gap-2 text-xs font-bold tracking-[0.25em] uppercase text-[#E85A1F]">
              <span className="w-8 h-px bg-[#E85A1F]" />
              ARSP compliant · ISO-aligned QC
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold tracking-[0.25em] uppercase text-white mb-5">
              {t.footer.navTitle}
            </h4>
            <ul className="space-y-3 text-sm">
              {[
                ["/", t.nav.home],
                ["/about", t.nav.about],
                ["/products", t.nav.products],
                ["/industries", t.nav.industries],
                ["/sustainability", t.nav.sustainability],
                ["/news", t.nav.news],
                ["/careers", t.nav.careers],
                ["/contact", t.nav.contact],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-neutral-400 hover:text-white transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold tracking-[0.25em] uppercase text-white mb-5">
              {t.footer.contactTitle}
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#E85A1F] mt-0.5 shrink-0" />
                <span>No. 44 Avenue Sendwe<br/>Lubumbashi, D.R. Congo</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#E85A1F] mt-0.5 shrink-0" />
                <div className="space-y-1">
                  <a href="tel:+243817106217" className="block hover:text-white">+243 817 106 217</a>
                  <a href="tel:+243833077650" className="block hover:text-white">+243 833 077 650</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <EnvelopeSimple size={18} className="text-[#E85A1F] mt-0.5 shrink-0" />
                <div className="space-y-1">
                  <a href="mailto:sales@masikachem.com" className="block hover:text-white">sales@masikachem.com</a>
                  <a href="mailto:saleskol@masikachem.com" className="block hover:text-white">saleskol@masikachem.com</a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-neutral-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-neutral-500">
          <p>© {year} Masika Chem SARL. {t.footer.rights}</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white inline-flex items-center gap-1">{t.footer.privacy} <ArrowUpRight size={12} /></a>
            <a href="#" className="hover:text-white inline-flex items-center gap-1">{t.footer.terms} <ArrowUpRight size={12} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
